import { useUpdateTaskStatusMutation } from "../../../features/tasks/tasksApi";

const Select = ({ id, status }) => {
  const [updateTaskStatus] = useUpdateTaskStatusMutation();

  const handleStatusChange = (e) => {
    updateTaskStatus({
      id,
      status: e.target.value,
      data: { status: e.target.value },
    });
  };

  return (
    <select className="lws-status" onChange={handleStatusChange}>
      <option
        value="pending"
        selected={status === "pending" || status === undefined}
      >
        Pending
      </option>
      <option value="inProgress" selected={status === "inProgress"}>
        In Progress
      </option>
      <option value="completed" selected={status === "completed"}>
        Completed
      </option>
    </select>
  );
};

export default Select;
